import { useNetworkRoute } from "../hooks/useNetworkRoute";
import ThreatIntelligenceContainer from "../../samples/containers/ThreatIntelligenceContainer";

export const getNormalizedValue = (iocValue?: string) =>
  iocValue?.replaceAll("/", "") ?? "";

const NetworkAttributionDataContainer = () => {
  const [networkRouteName, iocValue] = useNetworkRoute();

  // flask on cloud backend has problems with handling "/" (even if encoded) in the
  // path parameters (happens in the case of URL IOC), it might be
  // fixed in the future but for now we need to remove them and
  // fuzzy search will be able to find the correct IOC information
  return (
    <ThreatIntelligenceContainer
      ioc={
        networkRouteName === "url"
          ? getNormalizedValue(iocValue)
          : iocValue ?? ""
      }
      showHeader={false}
    />
  );
};

export default NetworkAttributionDataContainer;
